import React from "react";
import AnimatedSection from "@/components/animation/AnimatedSection/AnimatedSection";
import ContactForm from "@/components/ContactForm";
import { EnvironmentOutlined, PhoneOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ContactSection = () => {
  const { t } = useTranslation("contact");

  return (
    <section className="w-full bg-[#f8fafc] rounded-3xl shadow-sm px-4 sm:px-8 md:px-12 lg:px-16 py-10 sm:py-14 md:py-16 mt-6">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
        {/* Headline */}
        <div className="w-full lg:w-1/3">
          <h1 className="font-bold text-3xl sm:text-4xl lg:text-6xl mb-6 lg:mb-0 lg:pr-8 text-[#101616] leading-tight">
            {t("heading")}{" "}
            <span className="text-black">{t("headingAccent")}</span>
          </h1>
        </div>

        {/* Contact Info Cards */}
        <div className="w-full lg:w-2/3 flex flex-col md:flex-row gap-6 lg:gap-8 items-stretch">
          {/* Phone/Email Card */}
          <div className="flex-1">
            <div className="group bg-white/90 shadow-xl rounded-2xl p-6 sm:p-8 flex flex-col items-start hover:-translate-y-1 transition-all duration-300 h-full">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-white flex items-center justify-center text-3xl sm:text-4xl mb-4 border border-gray-200">
                <PhoneOutlined className="text-black" />
              </div>
              <div className="font-semibold text-lg sm:text-xl text-[#222] mb-2">
                {t("contactCard.title")}
              </div>
              <div className="text-base opacity-80 space-y-1 mt-auto">
                <div>
                  <span className="text-gray-500 text-sm">
                    {t("contactCard.phoneLabel")}:{" "}
                  </span>
                  <a
                    href="tel:+622140644888"
                    className="underline hover:text-black transition"
                  >
                    (021) 40644888
                  </a>
                </div>
                <div>
                  <span className="text-gray-500 text-sm">
                    {t("contactCard.faxLabel")}:{" "}
                  </span>
                  (021) 245 0519
                </div>
                <div>
                  <span className="text-gray-500 text-sm">
                    {t("contactCard.emailLabel")}:{" "}
                  </span>
                  <a
                    href="mailto:info@titancontainers.id"
                    className="underline hover:text-black transition"
                  >
                    info@titancontainers.id
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Address Card */}
          <div className="flex-1">
            <div className="group bg-white/90 shadow-xl rounded-2xl p-6 sm:p-8 flex flex-col items-start hover:-translate-y-1 transition-all duration-300 h-full">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-white flex items-center justify-center text-3xl sm:text-4xl mb-4 border border-gray-200">
                <EnvironmentOutlined className="text-black" />
              </div>
              <div className="font-semibold text-lg sm:text-xl text-[#222] mb-2">
                {t("addressCard.title")}
              </div>
              <div className="text-base opacity-80 space-y-0.5 mt-auto">
                <div>{t("addressCard.line1")}</div>
                <div>{t("addressCard.line2")}</div>
                <div>{t("addressCard.line3")}</div>
                <div>{t("addressCard.line4")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Google Maps Embed */}
      <div className="w-full flex justify-center mt-10 sm:mt-12">
        <div className="w-full max-w-3xl rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg border border-gray-100">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.5174350277717!2d106.8921041!3d-6.1734151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f50035e5ee93%3A0x4e0923ee7daf063e!2sThe%20Kensington%20Office%20Tower!5e0!3m2!1sen!2sid!4v1721641610254!5m2!1sen!2sid"
            width="100%"
            height="320"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={t("map.title")}
          ></iframe>
        </div>
      </div>
    </section>
  );
};

const ContactPage = () => {

  function ScrollToHash() {
    const { hash } = useLocation();

    useEffect(() => {
      if (!hash) return;
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, [hash]);

    return null;
  }


  return (
    <>
      <ScrollToHash />

      <AnimatedSection>
        <div className="mt-10 sm:mt-14">
          <ContactSection />
        </div>
      </AnimatedSection>

      <AnimatedSection>
        <div
          className="mt-10 sm:mt-14 px-4 sm:px-8 md:px-12 lg:px-16"
          id="request-form"
        >
          <ContactForm />
        </div>
      </AnimatedSection>
    </>
  );
};

export default ContactPage;
